import NavigationCategories from "components/Navigation/NavigationCategories"
import React, { Component, Fragment } from "react"
import FilterContainer from "components/Filter/FilterContainer"
// import {Link, IndexLink} from 'react-router-dom'
import { Header } from "semantic-ui-react"
import shop from "shop/shop"
import app from "app.controller"
import { observer } from "mobx-react"
import categoryStore from "stores/categoryStore"
import "components/Navigation/NavigationSidebar.scss"
import productStore from "stores/productStore"
import { Button, Container, Dropdown, Icon, Image, Menu, Modal } from "semantic-ui-react"
import { Link, NavLink }                                         from "react-router-dom"
import Responsive from "react-responsive"
import MediaQuery from "react-responsive"
import { SearchForm }              from "components/Search/SearchBarWithTypeahead"
import CartButton                                                from "components/Cart/CartButton"
import searchStore                 from "stores/searchStore"

@observer
export default class NavigationSidebar extends Component {
	constructor(props) {
		super(props)
		this.state = {
			categoryData: [],
			isClosed: true
		}
	}

	componentDidMount() {
		shop.events.loaded.add(this.onLoad)
	}

	onLoad = () => {
		this.setState({
			categoryData: shop.categories,
			isClosed: false
		})
	}

	componentWillUnmount() {
		shop.events.loaded.remove(this.onLoad)
	}

	close = () => {
		app.sidebarLeft.close.dispatch()
		this.setState({ isClosed: true })
	}

	render() {
		// const { hasFilter } = categoryStore
		const {showTitle = true} = this.props
		let categoryData         = categoryStore.categories
		const {currentCategory}  = productStore
		const {categoryId}       = currentCategory
		const category           = categoryStore.categoriesById.get(categoryId)
		const {hash} = categoryStore
		console.log("this.s")
		if(this.state.isClosed) {
			return null

		}
		return (
			<nav className="nav NavigationSidebar nav-sidebar pb4 h-100 overflow-y-auto overflow-x-auto">
				<FilterContainer category={category} query={this.props.query}/>
				<div className="mb6 limited-height NavigationMenuVertical">
					{showTitle && <Header as="h3">{translate("Kategorien")}</Header>}
					<NavigationCategories key={hash} categories={categoryData} />
					<div className="pa3 pl4">

					{((!shop.session) || (shop.session && shop.session.shopuser && shop.session.shopuser.guest)) && 
					<Button as={Link} to={`/login/?referrer=${document.location.pathname}`} primary>{translate( "Bestandskunden: Anmelden" )}</Button>}
					{shop.session && shop.session.shopuser && !shop.session.shopuser.guest &&
					<Button as={Link} to={`/logout/?referrer=${document.location.pathname}`} primary>{translate( "Abmelden" )}</Button>}
					<table className="w-100 pa3 pl4">
						<colgroup>
							<col width="50%"/>
							<col width="50%"/>
						</colgroup>
						<tbody>
						<tr>
							<td className="tc pt3 pr3">
								{shop.session && shop.session.shopuser && !shop.session.shopuser.guest && 
								<Button style={{maxWidth: "250px", maxHeight: "80px"}} onClick={app.sidebarLeft.close.dispatch} basic inverted={false} as={Link} to={"/account"}>
								<Icon className="user circle"></Icon></Button>}
								{((!shop.session) || (shop.session && shop.session.shopuser && shop.session.shopuser.guest)) &&
								<Button style={{maxWidth: "250px", maxHeight: "80px"}} onClick={app.sidebarLeft.close.dispatch} basic inverted={false} as={Link} to={"/login"}>
								<Icon className="user circle"></Icon></Button>}
							</td>
							<td className="tc pt3 pl3">
								<Button style={{maxWidth: "300px", maxHeight: "80px", minHeight: "80px"}} onClick={app.sidebarLeft.close.dispatch} basic inverted={false} as={Link} to={"/search/"}>
								<Icon className="search"></Icon></Button>
							</td>
						</tr>
						{shop.session && shop.session.shopuser && !shop.session.shopuser.guest && <tr>
							<td className="tc pt3 pr3">
								<Button style={{maxWidth: "250px", maxHeight: "80px"}} onClick={app.sidebarLeft.close.dispatch} basic inverted={false} as={Link} to={"/orderlist"}>
								<Icon className="heart"></Icon></Button>
							</td>
							<td className="tc pt3 pl3">
								<Button style={{maxWidth: "300px", maxHeight: "80px"}} onClick={app.sidebarLeft.close.dispatch} basic inverted={false} as={Link} to={"/quickorder"}>
								<Icon className="shopping basket"></Icon></Button>
							</td>
						</tr>}
						</tbody>	
					</table>
					</div>
				</div>
			</nav>
		)
	}
}



// WEBPACK FOOTER //
// ./src/theme/hvz/components/Navigation/NavigationSidebar.js